import { MyAccountUrl } from "../directives/utilities/urls";
export default function pendingDrops() {
    return {

        pendingDropScheduleList: [],
        totalRefund: 0,
       
        isPendingCoursesAvailableToDrop: true,
        isPendingCoursesAvailableToDropMessage: '',
        dropCoursesReasons: [],
        showErrorMesage: '',
        selectedReason: [],
        selectedOther: [],
        isCompleteDropCourses: [],
        isCompleteDropCoursesMessage: [],
        isRevertDropCourses: [],
        isRevertDropCoursesMessage: [],
        blankReasonCount: 0,
        blankOtherReasonCount:0,
        isCompletedDropCourses : true,
        isCompletedDropCoursesMessage :'',
        showLoader: false,
        selectedReasonAfterRevert: [{ serialId: '', selectedReason: '', selectedOtherReason: '' }], 
        isSubmitting: false,
        coursesToDrop: [],
        checkDropCoursesAllowed() {
            fetch('/api/StudentAPI/CheckDropCoursesAllowed', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        if (response.allowDropCourse) {
                            this.bindDropCoursesReasons();
                        }
                        else {
                            window.location.href = MyAccountUrl;
                        }

                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });

        },
        bindPendingDropSchedule() {
            this.showLoader = true;
            this.isRevertDropCourses = [];
            fetch('/api/StudentAPI/GetPendingDropSchedule', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {
                    this.showLoader = false;
                    if (response != undefined && response.isSuccess) {
                        this.pendingDropScheduleList = response.scheduleList;
                        if (this.pendingDropScheduleList.length <= 0) {
                            this.isPendingCoursesAvailableToDrop = false;
                            this.showLoader = false;
                            this.isPendingCoursesAvailableToDropMessage =
                                "You are currently not enrolled in any courses or the courses you are enrolled in have been completed.<br/><br/>" +
                                "To view your schedule <a class=\"font - weight - bold text - primary\" href=\"/my-account/my-schedule\">click here</a>.";
                        }
                        else {
                            this.isPendingCoursesAvailableToDrop = true;
                            this.isPendingCoursesAvailableToDropMessage = "";
                            for (let j = 0; j < this.pendingDropScheduleList.length; j++) {
                                if (this.pendingDropScheduleList[j].codeDropReason != "" || this.pendingDropScheduleList[j].codeDropReason !=null) {
                                    this.selectedReason[j] = this.pendingDropScheduleList[j].codeDropReason;
                                    this.selectedOther[j] = this.pendingDropScheduleList[j].noteDropReason;
                                    this.isRevertDropCourses[j] = "false";
                                }
                                else {
                                    this.selectedReason[j] = "";
                                    this.selectedOther[j] = "";
                                    this.isRevertDropCourses[j] = "false";
                                }

                            }
                            if (this.selectedReasonAfterRevert.length > 0) {
                                for (let j = 0; j < this.pendingDropScheduleList.length; j++) {
                                    for (let k = 0; k < this.selectedReasonAfterRevert.length; k++) {
                                        if (this.pendingDropScheduleList[j].serialId == this.selectedReasonAfterRevert[k].serialId) {
                                            this.selectedReason[j] = this.selectedReasonAfterRevert[k].selectedReason;
                                            this.selectedOther[j] = this.selectedReasonAfterRevert[k].selectedOtherReason;
                                            this.isRevertDropCourses[j] = "false";
                                        }
                                       
                                    }

                                }
                            }
                            this.totalRefund = response.totalRefund;
                        }
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later. to get pending courses available to drop";
                    }

                });

        },
        async bindDropCoursesReasons() {
            try {
                await new Promise(resolve => setTimeout(resolve, 1000));
                const response = await fetch('/api/Common/GetDropCoursesReasons');


                if (response.ok) {
                    const json = await response.json();
                    this.dropCoursesReasons = json;
                    this.bindPendingDropSchedule();
                    }
                    else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later. to get drop courses reasons."
                    }

            } catch (error) {
                console.error(error);
            }

        },
        AssessDrop() {
            fetch('/api/StudentAPI/AssessDrop', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({

                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response.isSuccess) {
                        this.showErrorMesage = "";
                        window.location.href = document.getElementById('dropCoursesSummaryPageUrl').value;
                    }
                    else {
                        this.showErrorMesage = "Something went wrong to get assess drop data."
                        this.isSubmitting = false;
                    }
                });
        },
        RevertDropCourses(item, index) {
            this.isRevertDropCourses = [];
            this.isRevertDropCoursesMessage = [];
            this.selectedReasonAfterRevert = [{ serialId: '', selectedReason: '', selectedOtherReason: '' }];
            this.selectedReasonAfterRevert.splice(0, 1);
            fetch('/api/StudentAPI/RevertDropCourses', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    AcademicYear: item.academicYear,
                    AcademicTerm: item.academicTerm,
                    AcademicSession: item.academicSession,
                    SerialId: item.serialId,
                    Section: item.section,
                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response.isSuccess) {
                        this.isRevertDropCourses[index] = "true";
                        this.isRevertDropCoursesMessage[index] = "";
                        for (let j = 0; j < this.pendingDropScheduleList.length; j++) {
                            this.selectedReasonAfterRevert.push({ serialId: this.pendingDropScheduleList[j].serialId, selectedReason: this.selectedReason[j], selectedOtherReason: this.selectedOther[j] });
                            
                        }
                        this.bindPendingDropSchedule();
                                }
                                else {
                                    this.isRevertDropCourses[index] = "false";
                                    this.isRevertDropCoursesMessage[index] = "Something went wrong."
                                }
                            });                  
        },
        
        CompleteDropCourses() {
            this.isSubmitting = true;
            this.blankReasonCount = 0;
            this.blankOtherReasonCount = 0;
            this.isCompleteDropCourses = [];
            this.isCompleteDropCoursesMessage = [];
            this.coursesToDrop = [];
            if (this.pendingDropScheduleList.length > 0) {
                for (let i = 0; i < this.pendingDropScheduleList.length; i++) {
                    if (this.selectedReason[i] === "" || this.selectedReason[i] === null) {
                        this.isCompleteDropCourses[i] = "false";
                        this.isCompleteDropCoursesMessage[i] = "Please select reason";
                        this.blankReasonCount += 1;
                        this.isSubmitting = false;
                    }
                    else {
                        this.isCompleteDropCourses[i] = "true";
                        this.isCompleteDropCoursesMessage[i] = "";

                    }
                    if (this.selectedReason[i] === "OTHREASON") {
                        if (this.selectedOther[i] === "" || this.selectedOther[i] === null) {
                            this.isCompleteDropCourses[i] = "false";
                            this.isCompleteDropCoursesMessage[i] = "Please enter other reason";
                            this.blankOtherReasonCount += 1;
                            this.isSubmitting = false;
                        }
                        else {
                            this.isCompleteDropCourses[i] = "true";
                            this.isCompleteDropCoursesMessage[i] = "";

                        }
                    }
                }
                if (this.blankReasonCount <= 0 && this.blankOtherReasonCount <= 0) {
                    for (let j = 0; j < this.pendingDropScheduleList.length; j++) {

                        if (this.selectedReason[j] != "") {
                            if (this.selectedReason[j] === "OTHREASON") {
                                if (this.selectedOther[j] != "" || this.selectedOther[j] != null) {
                                    
                                    this.coursesToDrop.push({
                                        AcademicYear: this.pendingDropScheduleList[j].academicYear,
                                        AcademicTerm: this.pendingDropScheduleList[j].academicTerm,
                                        AcademicSession: this.pendingDropScheduleList[j].academicSession,
                                        SerialId: this.pendingDropScheduleList[j].serialId,
                                        Section: this.pendingDropScheduleList[j].section,
                                        Note: this.selectedOther[j],
                                        Reason: this.selectedReason[j],

                                    });
                                    
                                }
                                else {
                                    this.isCompleteDropCourses[j] = "false";
                                    this.isCompleteDropCoursesMessage[j] = "Please give other reason";
                                    this.isSubmitting = false;
                                }

                            }
                            else {
                               
                                this.coursesToDrop.push({
                                    AcademicYear: this.pendingDropScheduleList[j].academicYear,
                                    AcademicTerm: this.pendingDropScheduleList[j].academicTerm,
                                    AcademicSession: this.pendingDropScheduleList[j].academicSession,
                                    SerialId: this.pendingDropScheduleList[j].serialId,
                                    Section: this.pendingDropScheduleList[j].section,
                                    Reason: this.selectedReason[j],
                                    Note: "",
                                });

                            }
                        }
                    }
                    this.callCourseCompleteAPI(this.coursesToDrop);
                }
            }
        },
        callCourseCompleteAPI(coursesToDrop) {
            fetch('/api/StudentAPI/CompleteDropCourses', {
                                            method: 'POST',
                                            headers: {
                                                'Accept': 'application/json',
                                                'Content-Type': 'application/json'
                                            },
                                            body: JSON.stringify(
                                                coursesToDrop
                                            )
                                        })
                                            .then(response => {
                                                if (response.ok) {
                                                    return response.json()
                                                }
                                            }).then(response => {

                                                if (response.isSuccess) {
                                                    this.isCompletedDropCourses = true;
                                                    this.AssessDrop();
                                                }
                                                else {
                                                    this.isCompletedDropCourses = false;
                                                    this.isCompletedDropCoursesMessage = "Something went wrong."
                                                    this.isSubmitting = false;
                                                }
                                            });
        },
        init() {
            this.showLoader = true;
            this.checkDropCoursesAllowed();
        }
    }
}